import React from 'react';
import { ViewPublicArchiveModal } from '../view-public-archive-modal.component';
import { useBailleursConfigurationFooterPromiseQuery } from 'common/api/query/bailleurs-configuration/footer.query';
import { useErrorNotification } from '@isyc-react/form/modules/context/notification-hub';
import { Spinner } from '@isyc-react/design/bootstrap';
export const FooterElementArchive = props => {
    const { footerType, text } = props;
    const [data, setData] = React.useState();
    const query = useBailleursConfigurationFooterPromiseQuery({ variables: { footerType } });
    const [toOpen, setToOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const addErrorNotification = useErrorNotification();
    React.useEffect(() => {
        if (toOpen) {
            query().then((data) => { setData(data); setOpen(true); })
                .catch(() => addErrorNotification('Une erreur est survenue lors de la récupération des données', { life: 5000 })).finally(() => setToOpen(false));
        }
    }, [toOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: 'list-inline-item me-xl-2 w-auto mb-0 align-items-center d-flex' },
            React.createElement("a", { onClick: () => setToOpen(true), title: text }, text)),
        toOpen && !open && (React.createElement(Spinner, { size: 'sm' })),
        open && data && React.createElement(ViewPublicArchiveModal, { show: open, onChange: () => setOpen(false), archive: data })));
};
